import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      error: {
        NOT_FOUND: 'Page Not Found',
        SERVER_ERROR: 'Internal Server Error',
        FORBIDDEN: 'Forbidden',
        GO_TO_DASHBOARD: 'GO TO DASHBOARD',
        BACK_TO_PREVIOUS_PAGE: 'BACK TO PREVIOUS PAGE',
        ERROR_454:
          'Your account has been active in another device.\nPlease log out and log in your registered device.',
        SIGN_OUT: 'Sign out',
        ACCOUNT_HAS_BEEN_LOGIN_FROM_ANOTHER_DEVICE:
          'Your account has been logged out because it is currently logged in on another device.',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      error: {
        NOT_FOUND: 'Không Tìm Được Trang',
        SERVER_ERROR: 'Lỗi Máy Chủ Nội Bộ',
        FORBIDDEN: 'Forbidden',
        GO_TO_DASHBOARD: 'CHUYỂN ĐẾN DASHBOARD',
        BACK_TO_PREVIOUS_PAGE: 'QUAY LẠI TRANG TRƯỚC',
        ERROR_454:
          'Tài khoản của bạn đã được đăng ký với thiết bị khác.\nHãy đăng xuất và đăng nhập bằng thiết bị đã đăng ký.',
        SIGN_OUT: 'Đăng xuất',
        ACCOUNT_HAS_BEEN_LOGIN_FROM_ANOTHER_DEVICE:
          'Tài khoản của bạn đã bị đăng xuất do đang được đăng nhập trên một thiết bị khác.',
      },
    },
  }),
)
